import { render, staticRenderFns } from "./FlmTable.vue?vue&type=template&id=77f2581c"
import script from "./FlmTable.vue?vue&type=script&lang=ts"
export * from "./FlmTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports